$(document).ready(function() {

	$('.js-tile-accordion').on('click', function() {

		if ($(window).width() < 768) {
			$(this).toggleClass('active');
			$(this).next('.b-tile-text-two__item').toggleClass('active');
		}
	})
});


// WEBPACK FOOTER //
// ./src/js/pages/promo/tile-accordion.js